module.exports = __webpack_public_path__ + "media/images/driver-e4456c21459f2b86265c64b42b50eebf.png";